import ConfirmJwt from '@fhs-legacy/frontend/src/pages/authentication/confirm-jwt';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default ConfirmJwt;
